// src/router/index.js
import { createRouter, createWebHashHistory } from 'vue-router'  // 引入 Vue Router 的相关函数

// 引入你希望路由到的组件
// 如果你的组件放在 views 目录下，路径可能是 '../views/Home.vue'
import Home from '../pages/HomeManage.vue'   // 根据你的实际组件路径修改
import About from '../pages/AboutManage.vue' // 根据你的实际组件路径修改

// 定义路由规则数组
const routes = [
    {
        path: '/',      // 访问路径
        name: 'Home',   // 路由名称（可选，但建议设置）
        component: Home // 对应的组件
    },

    {
        path: '/about',
        name: 'About',
        component: About
    },
    {
        path: '/details',
        name: 'Details',
        component: () => import("../pages/DetailsManage.vue"),
    },
    {
        path: '/cat',
        name: 'Cat',
        component: () => import("../pages/CatManage.vue"),
    },
    {
        path: '/dynamic',
        name: 'Dynamic',
        component: () => import("../pages/DynamicMaange.vue"),
    },
    {
        path: '/life',
        name: 'LIfe',
        component: () => import("../pages/LIfeManage.vue"),
    },
    {
        path: '/join',
        name: 'Join',
        component: () => import("../pages/JoinManage.vue"),
    },
    {
        path: '/want',
        name: 'Want',
        component: () => import("../pages/WantManage.vue"),
    },
    {
        path: '/news',
        name: 'News',
        component: () => import("../pages/NewsManage.vue"),
    },
]

// 创建路由实例
const router = createRouter({
    history: createWebHashHistory(),  // 使用 HTML5 History 模式
    routes // 传入路由规则配置
})

// 导出路由实例
export default router